<template>
  <div class="side-notifications">
    <div class="side-notifications__wrap">
      <BasePreloader v-if="pending"/>

      <OverlayScrollbarsComponent>
        <div v-if="notificationsNew.length || notificationsViewed.length"
             class="side-notifications__list">
          <template v-if="notificationsNew.length">
            <div class="side-notifications__list-title">
              {{ $tSidebar('New messages') }}
            </div>
            <div v-for="(item) in notificationsNew"
                 :key="item.id"
                 class="notification  _new">
              <!--            <div @click="deleteOne(index)" class="notification__delete">-->
              <!--              <BaseSvg name="ico-close" width="1rem" height="1rem"/>-->
              <!--            </div>-->
              <div class="notification__date">
                {{ getTime(item.datetime) }}
              </div>
              <!--            <div class="notification__title">-->
              <!--              {{ item.title }}-->
              <!--            </div>-->
              <div class="notification__message" v-html="item.message"/>
              <div class="notification__link-under-message-wrap">
                <router-link-modified v-if="item.interaction"
                                      :to="{name: 'account-interaction', params: {id: item.interaction}, query: {openChat: true}}"
                                      @click.native="closeNotifications"
                                      class="notification__link-under-message">
                  {{ $tSidebar('Go to chat') }}
                </router-link-modified>
              </div>
            </div>
          </template>
          <template v-if="notificationsViewed.length">
            <div class="side-notifications__list-title">
              {{ $tSidebar('Previous messages') }}
            </div>
            <div v-for="(item) in notificationsViewed"
                 :key="item.id"
                 class="notification  _viewed">
              <div class="notification__date">
                {{ getTime(item.datetime) }}
              </div>
              <div class="notification__message" v-html="item.message"/>
              <div v-if="item.interaction"
                   class="notification__link-under-message-wrap">
                <router-link-modified
                    :to="{name: 'account-interaction', params: {id: item.interaction}, query: {openChat: true}}"
                    @click.native="closeNotifications"
                    class="notification__link-under-message">
                  {{ $tSidebar('Go to chat') }}
                </router-link-modified>
              </div>
            </div>
          </template>
        </div>

        <div v-else-if="!pending">
          <div class="side-notifications__alert">
            <BaseAlert class="side-notifications__alert-inner _error"
                       :value="$tSidebar('You have no notifications yet')"/>
          </div>
        </div>
      </OverlayScrollbarsComponent>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex"
  import formatDate from "@/helpers/formatDate"
  import formatTime from "@/helpers/formatTime"
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';

  export default {
    name: "SideNotifications",
    components: {
      OverlayScrollbarsComponent
    },
    data() {
      return {}
    },
    computed: {
      ...mapState('user/userNotifications', [
        'pending',
        'open',
        'notificationsNew',
        'notificationsViewed',
      ]),
    },
    methods: {
      ...mapActions('user/userNotifications', [
        'load',
      ]),
      ...mapMutations('user/userNotifications', [
        'closeNotifications',
        'clearState',
      ]),
      getTime(date) {
        date = new Date(date * 1000)

        return formatDate(date) + ' ' + formatTime(date)
      }

    },
    created() {
      this.load()
    }
  }
</script>

<style scoped>

</style>
